import { Component } from 'react';

import './styles.css';

import img_logo from '../../assets/img/logo/jurisvip-all-transparente-menor.png';

class FooterComponent extends Component {
  render() {
    const { nomeEscritorio } = this.props;

    return (
      <footer className="footer-component">
        {/** biome-ignore lint/performance/noImgElement: necessário */}
        <img alt="logo" src={img_logo} />
        <p>
          Documento gerado pela plataforma JurisVip. Todas as informações <br />
          foram fornecidas pelo escritório {nomeEscritorio}.
        </p>
      </footer>
    );
  }
}

export default FooterComponent;
